import React, { useState, useEffect } from "react"
import algoliasearch from "algoliasearch/lite"
import {
  ResultItem,
  ResultName,
  ResultSubtitle,
  SectionHeader,
} from "../styles"
import {
  RANDOM_SUGGESTIONS_COUNT,
  RANDOM_SUGGESTIONS_FETCH_SIZE,
} from "../constants"
import { generateTitleFromSlug } from "../utils/titleExtraction"

interface Props {
  indexName: string
}

export function RandomDocSuggestions({ indexName }: Props) {
  const [suggestions, setSuggestions] = useState<
    Array<{ title: string; path: string }>
  >([])

  useEffect(() => {
    if (!indexName) return

    const searchClient = algoliasearch(
      process.env.GATSBY_ALGOLIA_APP_ID,
      process.env.GATSBY_ALGOLIA_SEARCH_KEY
    )
    const index = searchClient.initIndex(indexName)

    index
      .search("", {
        hitsPerPage: RANDOM_SUGGESTIONS_FETCH_SIZE,
      })
      .then(({ hits }) => {
        const allDocs = hits.map((hit: any) => {
          const firstSubheading = hit.subheadings
            ?.split(" ")
            .slice(0, 5)
            .join(" ")
            .trim()
          const fallbackTitle =
            firstSubheading || generateTitleFromSlug(hit.slug)
          const title = hit.h1 || fallbackTitle

          return {
            title,
            path: hit.slug,
          }
        })

        const shuffled = [...allDocs].sort(() => Math.random() - 0.5)
        setSuggestions(shuffled.slice(0, RANDOM_SUGGESTIONS_COUNT))
      })
      .catch((error) => {
        console.error("Failed to fetch doc suggestions:", error)
      })
  }, [indexName])

  if (suggestions.length === 0) return null

  return (
    <>
      <SectionHeader role="presentation">Try searching for:</SectionHeader>
      {suggestions.map((doc) => (
        <ResultItem
          key={doc.path}
          active={false}
          role="option"
          aria-selected={false}
          onClick={() => {
            if (typeof window !== "undefined") {
              window.location.href = doc.path
            }
          }}
        >
          <ResultName>{doc.title}</ResultName>
          <ResultSubtitle>{doc.path}</ResultSubtitle>
        </ResultItem>
      ))}
    </>
  )
}
